import { swRequest } from "./sw-request";

export const getAlerts = () =>
  swRequest({
    path: "/api/users/get_alerts",
  });
